'use client';

import { c as _c } from "react/compiler-runtime";
import { cx } from '@/src/styles/stylebook';
import { MenuBall } from '../frame/Ball';
export const Ham = t0 => {
  const $ = _c(17);
  const {
    status,
    setStatus
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cx("right-marg top-gutter h-ham w-ham fixed z-100 md:hidden");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== setStatus || $[2] !== status) {
    t2 = () => setStatus(!status);
    $[1] = setStatus;
    $[2] = status;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <MenuBall className="fill-gray-0 absolute top-0 left-0 h-full w-full" />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = status ? "top-[50%] rotate-45" : "top-[calc(50%-5.5px)] rotate-0";
  let t5;
  if ($[5] !== t4) {
    t5 = cx("absolute left-1/2 h-[4px] w-[24px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-green-50 transition-all duration-300 ease-in-out", t4);
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t5) {
    t6 = <div className={t5} />;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const t7 = status ? "top-[50%] -rotate-45" : "top-[calc(50%+5.5px)] rotate-0";
  let t8;
  if ($[9] !== t7) {
    t8 = cx("absolute left-1/2 h-[4px] w-[24px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-green-50 transition-all duration-300 ease-in-out", t7);
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t8) {
    t9 = <div className={t8} />;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t2 || $[14] !== t6 || $[15] !== t9) {
    t10 = <button className={t1} onClick={t2}>{t3}{t6}{t9}</button>;
    $[13] = t2;
    $[14] = t6;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  return t10;
};